import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import HelpIcon from '@mui/icons-material/HelpRounded';

export default function Confirmation(props) {
    const [data, setData] = useState(props.data)
        
    return (
        <Dialog open={props.data ? true : false} onClose={() => {props.onResponse(false)}} fullWidth maxWidth="xs" >
            <DialogTitle id="alert-dialog-title">
                {props.title ?? 'Confirmation'}
            </DialogTitle>
            <DialogContent>
                <Stack direction="row" spacing={2}>
                    <HelpIcon color="primary" sx={{ fontSize:40 }}/>
                    <DialogContentText>
                        {props.content ?? 'Are You Sure?'}
                    </DialogContentText>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {props.onResponse(false)}}>{props.labelNo ?? 'No'}</Button>
                <Button onClick={() => {props.onResponse(true)}} autoFocus>{props.labelYes ?? 'Yes'}</Button>
            </DialogActions>
        </Dialog>
    )
}